import FolderEditModal from './FolderEditModal';

export default FolderEditModal;
